module.exports = __webpack_public_path__ + "img/hr-branch-particle-15.9fdb4cd1.png";